<template>
    <div class="home">
        <side-bar>
            <top-nav></top-nav>
            <ac-grid cols="12" align-h="center">
                <ac-col cols="12" lg-cols="10">
                    <div class="grid-3">
                        <div class="col-3 col-offset-md-1 col-md-1 color-square-wrapper"><color-square :color="$store.state.currentColor"></color-square></div>
                        <div class="col-3 col-md-1"><div class="recenter-button-wrapper"><span @click="recenterToggleLists" class="recenter-button"><font-awesome-icon icon="crosshairs"></font-awesome-icon></span></div></div>
                    </div>
                    <div class="grid-3">
                        <div class="col-1" v-for="i in 3" :key="i">
                            <h2 class="color-list-header">{{colorToggleConfig.headers[i-1]}}</h2>
                            <color-toggle-list 
                                :color="$store.state.currentColor" 
                                :mode="colorToggleConfig.name" 
                                :increment="$store.state.colorToggleIncrement[colorToggleConfig.name][i-1]" 
                                :col="i-1" 
                                :min="colorToggleConfig.min[i-1]" 
                                :max="colorToggleConfig.max[i-1]"></color-toggle-list>
                        </div>
                    </div>
                </ac-col>
            </ac-grid>
        </side-bar>
     </div>
</template>

<script>    

import topNav from "@/components/topNav.vue";
import sideBar from "@/components/sideBar.vue";
import colorSquare from "@/components/colorSquare.vue";
import colorToggleList from "@/components/colorToggleList.vue";

export default {
    name: 'home',
    data(){
        return {
        };
    },
    components: {
        "color-square":colorSquare,
        "color-toggle-list":colorToggleList,
        "side-bar":sideBar,
        "top-nav":topNav,
    },
    methods:{
        recenterToggleLists(){
            let toggleLists = [...document.getElementsByClassName("color-toggle-list")];
            toggleLists.forEach((list)=>{
                let listHeight = list.getBoundingClientRect().height;
                let currentColorItem = [...list.getElementsByClassName("currentColor")];
                if(currentColorItem.length>0){
                    let itemHeight= currentColorItem[0].getBoundingClientRect().height;
                    currentColorItem[0].scrollIntoView();
                    list.scrollTop-=listHeight/2-itemHeight/2;
                }
            })
        },
    },
    computed:{
        currentColor(){
            if(!this.color){
                return (new this.$store.state.Color());
            }else{
                return this.color;
            }
        },
        currentColorItemCount(){
            return document.getElementsByClassName("currentColor").length;
        },
        authValid(){
            return this.$store.state.authValid;
        },
        themeUpdated(){
            return this.$store.state.themeUpdated;
        },
        currentThemeName(){
            return this.$store.state.currentThemeName;
        },
        colorToggleConfig(){
            return this.$store.state.colorToggleConfig[this.$store.state.colorToggleMode]
        }
    },
    created(){
        this.$store.commit('setCurrentColor', this.$store.state.Color.random());
        this.$store.commit('toggleCurrentThemeColor', this.$store.state.currentColor);
    },
    mounted(){
        this.recenterToggleLists();
    },
    watch:{
        authValid(){
            this.updateTheme();
        },
        themeUpdated(){
            if(!this.themeUpdated){
                this.updateTheme();
            }
        },
        currentThemeName(){
            document.title = this.currentThemeName + " | Acute Colors"; 
        }
    }
}
</script>
<style type="text/css">
    .color-square-wrapper div{
        margin: 2% auto;
    }
    .color-list-header{
        text-transform: uppercase;
        color: #FFF;
        justify-content: center;
        padding-bottom: 2%;
        font-size: 0;
        display: block;
        text-align: center;
    }
    h2.color-list-header::first-letter{
        font-size: 2rem;
    }
    .color-list-header span{
        display: none;
    }
    @media screen and (min-width: 992px){
        .color-list-header span{
            display: inline;
        }
    }
    .recenter-button-wrapper{    
        text-align: center;
        display: flex;
        height: 100%;
        justify-content: center;
        align-items: center;
    }
    .recenter-button{
        padding: 4%;
        margin: 2%;
        border-radius: 50%;
        background-color: rgba(0,0,0,0.3);
        transition: background-color, 0.15s ease-in-out;
        color: #FFF;
        cursor: pointer;
    }
    .recenter-button:hover{
        background-color: rgba(0,0,0,0.5);
    }
    @media screen and (min-width: 1030px){   
        .color-list-header{
            font-size: 2em;
        }
    }
</style>
